import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { VERIFY_OTP } from "../routes";
import api from "../api";
import { toast } from "react-toastify";
import { redirectUser } from "../resource";

export const loginUser = createAsyncThunk(
  "ls/loginUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.post(`/user-auth/login`, payload);
      localStorage.setItem(
        "gida_token",
        JSON.stringify(response?.data?.data, null, 2)
      );
      if (
        response?.data?.data?.user?.role === "Landlord" ||
        response?.data?.data?.user?.role === "Super_Admin"
      ) {
        redirectUser("/dashboard");
      } else {
        redirectUser("/");
      }
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createUser = createAsyncThunk(
  "ls/createUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.post(`/user-auth/signup`, payload);
      redirectUser(VERIFY_OTP);
      return response.data;
    } catch (error) {
      // console.log({ error });
      toast.error(error?.response?.data?.message || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  auth: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    [loginUser.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [loginUser.fulfilled]: (state, action) => {
      return { ...state, loginResponse: action.payload, loading: false };
    },
    [loginUser.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [createUser.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [createUser.fulfilled]: (state, action) => {
      return { ...state, registerResponse: action.payload, loading: false };
    },
    [createUser.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export default authSlice.reducer;
